export default "__VITE_ASSET__DLWX$vNI__"